<script>
    export let category_id, subcategory_id, control_id;
    export let assessment_type;

    import {db} from '../../Database.svelte';
    import Loader from '../Loader.svelte';
    import QuestionLibrary from '../../Models/QuestionLibraryModel';
    import {clean} from '../../Utilities/Cleaner.svelte';
    import ReferencesField from '../../Forms/CustomFields/ReferencesField.svelte';
    import Tags from '../Tags.svelte';
    import { notifier } from "@beyonk/svelte-notifications";

    import QuestionTypes from '../../lib/QuestionTypes';
    import {sortBy} from 'lodash-es';

    import  TagMappingModal, {showMappingModal} from '../TagMappingModal.svelte';


    $: category = Object.values(assessment_type.categories).filter(c => c.details._id == category_id)[0].details;
    let subcategory = QuestionLibrary.getStore(subcategory_id);
    let control;

    function loadData(subcategory) {
        if (!subcategory) return;

        for (let ctrl of subcategory.controls) {
            if (ctrl.details.child_id != control_id) continue

            control = ctrl;
            break
        }


    }

    function getLink(ctrl) {
        let library_id = ctrl.id.split(":").slice(0, 2).join(":");

        return `#/questionLibrary/${library_id}/${ctrl.id}`
    }

    function addAnswerMapping(answer) {
        showMappingModal().then((mapping) => {
            assessment_type.model.addLibraryControlAnswerMap(control_id, answer, mapping).then(() => {
                notifier.success("Mapping Added");
            })
        });
    }

    function removeAnswerMapping(mapping) {
        assessment_type.model.deleteLibraryControlAnswerMap(mapping).then(() => {
            notifier.success("Mapping Removed");
        })
    }

    function addTagMapping(tag) {
        showMappingModal().then((mapping) => {
            assessment_type.model.addLibraryControlTagMap(control_id, tag.tag_id, mapping).then(() => {
                notifier.success("Mapping Added");
            })
        })
    }

    function removeTagMapping(mapping) {
        assessment_type.model.deleteLibraryControlAnswerMap(mapping).then(() => {
            notifier.success("Mapping Removed");
        })
    }

    function getSection(section_id) {
        for (let section of assessment_type.report_sections) {
            if (section.section_id == section_id) {
                return section
            }
        }
    }

    async function getControlAnswerMappings(assessment_type, answer) {
        let section_mappings = [];
        if (
            assessment_type.library_control_answer_mappings[control_id]
        ) {
            for (let mapping of assessment_type.library_control_answer_mappings[control_id]) {
                if (mapping.answer != answer) continue;

                let section = getSection(mapping.map.section_id);
                let library_item = await db.get(mapping.map.id);
                section_mappings.push({
                    id: mapping._id,
                    type: section.section_name,
                    text: library_item.name,
                    mapping
                })
            }
        }

        return section_mappings;
    }

    async function getControlTagMappings(assessment_type, tag) {
        let section_mappings = [];
        if (
            assessment_type.library_control_tag_mappings[control_id]
        ) {
            for (let mapping of assessment_type.library_control_tag_mappings[control_id]) {
                if (mapping.tag_id != tag.tag_id) continue;

                let section = getSection(mapping.map.section_id);
                let library_item = await db.get(mapping.map.id);
                section_mappings.push({
                    id: mapping._id,
                    type: section.section_name,
                    text: library_item.name,
                    mapping,
                    section
                })
            }
        }

        return section_mappings;
    }

    async function getLibraryAnswerMappings(answer) {
        const answer_mappings = [...control.answer_mappings].filter((m) => m.details.answer == answer);
        let section_mappings = [];
        for (let section of assessment_type.report_sections) {
            if (section.section_type == "library" && !section.exclude_mappings) {
                for (let mapping of answer_mappings) {
                    if (mapping.details.map.library_id == section.library_type) {
                        let library_item = await db.get(mapping.details.map.id);
                        section_mappings.push({
                            section,
                            type: section.section_name,
                            text: library_item.name,
                            mapping
                        })
                    }
                }
            }
        }

        return section_mappings;
    }

    async function getLibraryTagMappings(tag) {
        const tag_mappings = [...control.tag_mappings].filter(m => m.details.tag == tag.tag_id)
        let section_mappings = [];

        for (let section of assessment_type.report_sections) {
            if (section.section_type == "library" && !section.exclude_mappings) {
                for (let mapping of tag_mappings) {
                    if (mapping.details.map.library_id == section.library_type) {
                        let library_item = await db.get(mapping.details.map.id);
                        section_mappings.push({
                            section,
                            type: section.section_name,
                            text: library_item.name,
                            mapping
                        })
                    }
                }
            }
        }

        return section_mappings;
    }

    function checkDisabledMapping(assessment_type, map) {
        for (let disabled_map of assessment_type.disabled_mappings) {
            if (disabled_map.map.map_id == map.mapping.id && disabled_map.map.section_id == map.section.section_id) {
                return true;
            }
        }
        return false;
    }

    function disableMapping(map) {
        let disabled_map = {
            map_id: map.mapping.id,
            section_id: map.section.section_id
        }
        assessment_type.model.disableLibraryControlMap(disabled_map).then(() => {
            notifier.success("Mapping Disabled")
        })
    }

    function enableMapping(map) {
        for (let disabled_map of assessment_type.disabled_mappings) {
            if (disabled_map.map.map_id == map.mapping.id && disabled_map.map.section_id == map.section.section_id) {
                assessment_type.model.enableLibraryControlMap(disabled_map).then(() => {
                    notifier.success("Mapping Enabled");
                });
                return;
            }
        }
    }

    async function excludeControl(control) {
        category.include_controls = category.include_controls.filter(c => c != control.details.child_id);

        await db.put(category);

        notifier.success("Control Excluded")
    }

    async function includeControl(control) {
        category.include_controls = [...category.include_controls, control.details.child_id];

        await db.put(category);

        notifier.success("Control Included")
    }

    $: loadData($subcategory);
</script>

<Loader loading={!control}>
    <div class="box">
        <div class="buttons top">
            {#if category.include_controls.includes(control.details.child_id)}
                <button class="button is-danger" on:click={() => excludeControl(control)}>Exclude Control</button>
            {:else}
                <button class="button is-success" on:click={() => includeControl(control)}>Include Control</button>
            {/if}
            <a href="{getLink(control)}" class="button is-info">
                Edit Library Control
            </a>
        </div>
        <div class="columns">
            <div class="field column is-narrow">
                <label class="label" for="input_control_number">Control Number</label>
                <div class="control">
                    <input type="text" class="input title is-4" value={control.details.control_number} id="input_control_number" readonly=true disabled=true>
                </div>
            </div>
            <div class="field column">
                <label class="label" for="input_control_name">Control Title</label>
                <div class="control">
                    <input type="text" class="input title is-4 disabled" value={control.details.name} id="input_control_name" readonly=true disabled=true>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column flex">
                <h3 class="title is-4">Control Text</h3>
                <textarea class="textarea is-size-4 flex-grow" value={control.details.text} disabled=true></textarea>
            </div>
            <div class="column">
                <h3 class="title is-4">Control Level</h3>
                <div class="select is-fullwidth">
                    <select value={control.details.level} disabled=true>
                        <option value="1">Level 1</option>
                        <option value="2">Level 2</option>
                        <option value="3">Level 3</option>
                        <option value="4">Level 4</option>
                        <option value="5">Level 5</option>
                    </select>
                </div>
                <h3 class="title is-4">Answer Type</h3>
                <div class="select is-fullwidth">
                    <select value={control.details.question_type} disabled=true>
                        <option value="implementation_status_new">Implementation Status</option>
                        <option value="yes_no_new">Yes/No</option>

                        <option value="implementation_status">Implementation Status (old)</option>
                        <option value="yes_no">Yes/No (old)</option>
                        <option value="free_text">Free Text</option>
                    </select>
                </div>
                <h3 class="title is-4">References</h3>
                <ReferencesField value={control.details.references} disabled=true />

                <h3 class="title is-4">Topic Tags</h3>
                <div class="field is-grouped- is-grouped-multiline">
                    <div class="control">
                        <Tags tags={control.details.topic_tags} addKeys={[9,13]} disable={true} />
                    </div>
                </div>
            </div>
        </div>

        <div class="columns flex-grow">
            <div class="column">
                <h1 class="title is-4">Library Mappings</h1>
                <h2 class="title is-5">Answer Mappings</h2>
                <table class="table is-striped is-fullwidth">
                    <thead>
                        <tr>
                            <th>Answer</th>
                            <th>Mappings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#if control.details.question_type != "free_text"}
                            {#each sortBy(Object.values(QuestionTypes[control.details.question_type].buttons), ["order"]) as btn (btn.label)}
                                {#await getLibraryAnswerMappings(btn.value)}
                                    Loading....
                                {:then section_mappings}
                                    {#if section_mappings.length}
                                        <tr>
                                            <th>{btn.label}</th>
                                            <td>
                                                <table class="table is-fullwidth">
                                                    <thead>
                                                        <tr>
                                                            <th>Section</th>
                                                            <th>Mapping Value</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {#each section_mappings as mapping ([mapping.type, mapping.id])}
                                                            <tr>
                                                                <td class="has-text-centered">
                                                                    {mapping.type}
                                                                </td>
                                                                <td class="prewrap">
                                                                    {mapping.text}
                                                                </td>
                                                                <td class="is-h-centered">
                                                                    {#if checkDisabledMapping(assessment_type, mapping)}
                                                                        <button class="button is-success" on:click={() => enableMapping(mapping)}>Enable</button>
                                                                    {:else}
                                                                        <button class="button is-danger" on:click={() => disableMapping(mapping)}>Disable</button>
                                                                    {/if}
                                                                </td>
                                                            </tr>
                                                        {/each}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    {/if}
                                {/await}
                            {/each}
                        {/if}
                    </tbody>
                </table>
                <h2 class="title is-5">Tag Mappings</h2>
                <table class="table is-striped is-fullwidth">
                    <thead>
                        <tr>
                            <th>Tag</th>
                            <th>Mappings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each assessment_type.question_tags as tag}
                            {#await getLibraryTagMappings(tag)}
                                Loading....
                            {:then section_mappings}
                                {#if section_mappings.length}
                                    <tr>
                                        <th>
                                            {tag.name}
                                        </th>
                                        <td>
                                            <table class="table is-fullwidth">
                                                <thead>
                                                    <tr>
                                                        <th>Section</th>
                                                        <th>Mapping Value</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {#each section_mappings as mapping ([mapping.type, mapping.id])}
                                                        <tr>
                                                            <td class="has-text-centered">
                                                                {mapping.type}
                                                            </td>
                                                            <td class="prewrap">
                                                                {mapping.text}
                                                            </td>
                                                            <td class="is-h-centered">
                                                                {#if checkDisabledMapping(assessment_type, mapping)}
                                                                    <button class="button is-success" on:click={() => enableMapping(mapping)}>Enable</button>
                                                                {:else}
                                                                    <button class="button is-danger" on:click={() => disableMapping(mapping)}>Disable</button>
                                                                {/if}
                                                            </td>
                                                        </tr>
                                                    {/each}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                {/if}
                            {/await}
                        {/each}
                    </tbody>
                </table>

                <div class="flex-grow">
                    <h3 class="title is-4">Supplemental Guidance</h3>
                    <div class="is-size-5 flex-grow">
                        <div class="guidance">
                            {@html clean(control.details.guidance)}
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <h1 class="title is-4">Question Mappings</h1>
                <h2 class="title is-5">Answer Mappings</h2>
                <table class="table is-striped is-fullwidth">
                    <thead>
                        <tr>
                            <th>Answer</th>
                            <th>Mappings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#if control.details.question_type != "free_text"}
                            {#each sortBy(Object.values(QuestionTypes[control.details.question_type].buttons), ["order"]) as btn (btn.label)}
                                <tr>
                                    <th>{btn.label}</th>
                                    <td>
                                        <table class="table is-fullwidth">
                                            <thead>
                                                <tr>
                                                    <th>Section</th>
                                                    <th>Mapping Value</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                    <td colspan=3>
                                                        <button class="button is-pulled-right is-info" on:click={() => addAnswerMapping(btn.value)}>Add Mapping</button>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                                {#await getControlAnswerMappings(assessment_type, btn.value)}
                                                    Loading...
                                                {:then mappings}
                                                    {#each mappings as mapping (mapping.id)}
                                                        <tr>
                                                            <td class="has-text-centered">
                                                                {mapping.type}
                                                            </td>
                                                            <td class="prewrap">
                                                                {mapping.text}
                                                            </td>
                                                            <td class="is-h-centered">
                                                                <button class="button is-danger" on:click={() => removeAnswerMapping(mapping.mapping)}>Delete</button>
                                                            </td>
                                                        </tr>
                                                    {/each}
                                                {/await}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            {/each}
                        {/if}
                    </tbody>
                </table>

                <h2 class="title is-5">Tag Mappings</h2>
                <table class="table is-striped is-fullwidth">
                    <thead>
                        <tr>
                            <th>Answer</th>
                            <th>Mappings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each assessment_type.question_tags as tag (tag.tag_id)}
                            <tr>
                                <th>{tag.name}</th>
                                <td>
                                    <table class="table is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>Section</th>
                                                <th>Mapping Value</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tfoot>
                                            <tr>
                                                <td colspan=3>
                                                    <button class="button is-pulled-right is-info" on:click={() => addTagMapping(tag)}>Add Mapping</button>
                                                </td>
                                            </tr>
                                        </tfoot>
                                        <tbody>
                                            {#await getControlTagMappings(assessment_type, tag)}
                                                Loading...
                                            {:then mappings}
                                                {#each mappings as mapping (mapping.id)}
                                                    <tr>
                                                        <td class="has-text-centered">
                                                            {mapping.type}
                                                        </td>
                                                        <td class="prewrap">
                                                            {mapping.text}
                                                        </td>
                                                        <td class="is-h-centered">
                                                            <button class="button is-danger" on:click={() => removeTagMapping(mapping.mapping)}>Delete</button>
                                                        </td>
                                                    </tr>
                                                {/each}
                                            {/await}
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</Loader>

<TagMappingModal {assessment_type} />

<style>
    th {
        text-align: center;
        vertical-align: middle;
    }

    table table {
        background-color: transparent;
        table-layout: fixed;
    }

    .buttons.top {
        display: flex;
        justify-content: space-between;
    }
</style>